import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'spaceDash',
})
export class SpaceDashPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    const string_without_spaces = value.replace(/\s+/g, '-').toLowerCase();
    return string_without_spaces;
  }
}
